<span
  class="date-toggle"
  [title]="getTitle()"
  (click)="toggle()"
>
  {{ getContent() }}
</span>
